<template>
    <stepper
        class="pt-8 lg:pt-16"
        primary-color="#3a473c"
        @step-click="go($event)"
    ></stepper>
</template>

<script>
export default {
    methods: {
        go(routeName) {
            this.$router.push({ name: routeName });
        }
    },
}
</script>
